<template>
  <div class="safe-area" id="reviews">
    <!-- Logo and Label -->
    <div class="md:text-center mb-6">
      <div class="flex items-center md:justify-center">
        <div class="w-12 h-12 rounded-lg flex items-center md:justify-center">
          <svg
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_394_3034)">
              <g clip-path="url(#clip1_394_3034)">
                <path
                  d="M26.9984 14.7852H18.2377C16.7257 14.7852 15.5 16.0109 15.5 17.5229V26.2835C15.5 27.7955 16.7257 29.0212 18.2377 29.0212H26.9984C28.5104 29.0212 29.7361 27.7955 29.7361 26.2835V17.5229C29.7361 16.0109 28.5104 14.7852 26.9984 14.7852Z"
                  stroke="#684DF4"
                  stroke-width="1.09508"
                />
                <path
                  d="M12.762 14.7852H4.00138C2.48938 14.7852 1.26367 16.0109 1.26367 17.5229V26.2835C1.26367 27.7955 2.48938 29.0212 4.00138 29.0212H12.762C14.274 29.0212 15.4997 27.7955 15.4997 26.2835V17.5229C15.4997 16.0109 14.274 14.7852 12.762 14.7852Z"
                  stroke="#684DF4"
                  stroke-width="1.09508"
                />
                <path
                  d="M26.9984 0.546875H18.2377C16.7257 0.546875 15.5 1.77259 15.5 3.28458V12.0452C15.5 13.5572 16.7257 14.7829 18.2377 14.7829H26.9984C28.5104 14.7829 29.7361 13.5572 29.7361 12.0452V3.28458C29.7361 1.77259 28.5104 0.546875 26.9984 0.546875Z"
                  stroke="#684DF4"
                  stroke-width="1.09508"
                />
                <path
                  d="M12.762 0.546875H4.00138C2.48938 0.546875 1.26367 1.77259 1.26367 3.28458V12.0452C1.26367 13.5572 2.48938 14.7829 4.00138 14.7829H12.762C14.274 14.7829 15.4997 13.5572 15.4997 12.0452V3.28458C15.4997 1.77259 14.274 0.546875 12.762 0.546875Z"
                  stroke="#684DF4"
                  stroke-width="1.09508"
                />
                <path
                  d="M20.4281 6.57031H10.5724C8.75796 6.57031 7.28711 8.04117 7.28711 9.85556V19.7113C7.28711 21.5257 8.75796 22.9965 10.5724 22.9965H20.4281C22.2425 22.9965 23.7133 21.5257 23.7133 19.7113V9.85556C23.7133 8.04117 22.2425 6.57031 20.4281 6.57031Z"
                  fill="#684DF4"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_394_3034">
                <rect
                  width="29.5672"
                  height="29.5672"
                  fill="white"
                  transform="translate(0.716797)"
                />
              </clipPath>
              <clipPath id="clip1_394_3034">
                <rect
                  width="29.5672"
                  height="29.5672"
                  fill="white"
                  transform="translate(0.716797)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <span class="text-indigo-600 font-semibold uppercase"
          >Customer Feedback</span
        >
      </div>

      <!-- Heading -->
      <h2 class="heading-2">
        What Happy Clients Say
        <span class="block text-indigo-600">About Us?</span>
      </h2>
    </div>
    <swiper
      class="mySwiper py-10"
      :slides-per-view="4"
      :space-between="20"
      :breakpoints="{
        320: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },
      }"
      :navigation="{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }"
      :pagination="{ clickable: true }"
      loop
      :modules="modules"
    >
      <swiper-slide
        v-for="(data, index) in customerReview"
        :key="index"
        class="py-10 select-none grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 px-6 space-x-4 relative"
      >
        <div class="relative w-full">
          <svg
            class="absolute -left-5 -top-5"
            width="21"
            height="17"
            viewBox="0 0 21 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.557153 12.6806L0.475638 12.2877C0.463686 12.1862 0.453855 12.0845 0.446151 11.9825L0.445519 11.9751C0.403961 11.5345 0.38336 10.916 0.417751 10.1657C0.459175 9.42102 0.565877 8.55437 0.802776 7.64476C0.928208 7.19004 1.08059 6.72552 1.26822 6.27366C1.29035 6.22552 1.31214 6.17785 1.33374 6.13065C1.5296 5.70234 1.70806 5.31211 1.95779 4.95368L1.96784 4.93926L1.97658 4.92402C2.21698 4.50486 2.53132 4.12882 2.8703 3.7498L2.88035 3.73856L2.88954 3.72659C3.02069 3.55561 3.18012 3.40516 3.36142 3.25083C3.41947 3.20141 3.48396 3.14829 3.55096 3.09311C3.67574 2.99034 3.80922 2.8804 3.92609 2.77378C4.0816 2.64069 4.25194 2.52844 4.43602 2.417C4.49369 2.38209 4.55585 2.34549 4.6199 2.30777C4.7497 2.23134 4.88725 2.15035 5.0109 2.06959L5.01936 2.0639C5.16304 1.96474 5.31782 1.89076 5.48805 1.82017C5.53922 1.79896 5.59698 1.77614 5.6576 1.75218C5.77544 1.70562 5.90414 1.65476 6.01653 1.60303C6.1143 1.56381 6.2023 1.52692 6.28308 1.49307C6.50946 1.39818 6.67902 1.32713 6.84737 1.29511L6.86054 1.29261L6.8735 1.28923C7.0339 1.24743 7.17371 1.21199 7.30336 1.17912C7.4017 1.15419 7.49418 1.13075 7.58538 1.10713C7.58604 1.10696 7.5867 1.10679 7.58736 1.10662L7.81206 1.05078L8.13959 2.40325L7.96016 2.48012L7.95896 2.48063L7.41462 2.71171C7.26745 2.76285 7.13503 2.8358 7.02069 2.90454C6.96705 2.9368 6.91317 2.97076 6.86255 3.00267L6.84568 3.0133C6.78877 3.04915 6.73485 3.08291 6.6801 3.11526L6.66833 3.12221L6.65706 3.12996C6.59173 3.17485 6.52855 3.21066 6.4499 3.25525C6.40758 3.27924 6.36079 3.30577 6.30677 3.33762C6.16993 3.41829 6.00895 3.52199 5.86307 3.66889C5.7923 3.73605 5.71784 3.79584 5.62858 3.8675C5.59627 3.89344 5.56202 3.92093 5.52531 3.9509C5.39523 4.05709 5.24552 4.18608 5.11424 4.34898L5.10973 4.35459L5.10542 4.36036C5.04478 4.44141 4.98084 4.51105 4.90281 4.59604C4.87082 4.63088 4.83647 4.66829 4.79901 4.71013C4.68494 4.83753 4.55455 4.99392 4.45442 5.18954C4.45108 5.19477 4.44773 5.20001 4.44438 5.20525C4.27453 5.47105 4.07983 5.77573 3.94902 6.12906C3.81784 6.38799 3.73754 6.6663 3.67019 6.8997L3.66852 6.90548L3.49569 7.50443L4.11218 7.41195C4.12674 7.40977 4.14112 7.4076 4.15535 7.40546C4.36666 7.37363 4.54415 7.34691 4.72683 7.34691C5.52982 7.34663 6.3175 7.58064 6.99859 8.02313C7.67981 8.4657 8.22719 9.09918 8.57591 9.8515C8.92455 10.604 9.05975 11.4436 8.96503 12.2729C8.87039 13.1022 8.54991 13.8857 8.04215 14.533C7.53452 15.1802 6.86072 15.6645 6.09975 15.9314C5.3389 16.1985 4.52072 16.2378 3.73937 16.0453C2.95792 15.8529 2.24374 15.4358 1.68012 14.8409C1.11641 14.2457 0.72652 13.4969 0.557153 12.6806ZM19.217 1.05292L19.5444 2.40483C19.4914 2.42726 19.4322 2.45228 19.3671 2.47968L19.3661 2.48012L18.8206 2.71171C18.6734 2.76285 18.541 2.8358 18.4266 2.90454C18.3729 2.93685 18.319 2.97086 18.2682 3.00281L18.2516 3.0133C18.1947 3.04915 18.1408 3.08291 18.0861 3.11526L18.0742 3.12221L18.063 3.12996C17.9977 3.17485 17.9345 3.21066 17.8558 3.25525C17.8135 3.27924 17.7667 3.30577 17.7127 3.33762C17.5758 3.41829 17.4149 3.52199 17.269 3.66889C17.1982 3.73605 17.1238 3.79584 17.0345 3.8675C17.0022 3.89345 16.968 3.92094 16.9313 3.9509C16.8012 4.05708 16.6514 4.18608 16.5202 4.34898L16.5157 4.35459L16.5114 4.36036C16.4507 4.44141 16.3868 4.51105 16.3087 4.59604C16.2768 4.63087 16.2424 4.66829 16.205 4.71013C16.0909 4.83753 15.9605 4.99392 15.8603 5.18955C15.857 5.19477 15.8537 5.20001 15.8503 5.20525C15.6805 5.47105 15.4858 5.77573 15.355 6.12906C15.2238 6.38801 15.1434 6.66633 15.0761 6.89973L15.0745 6.90548L14.9016 7.50443L15.5182 7.41195C15.5326 7.40977 15.547 7.4076 15.5613 7.40546C15.7726 7.37364 15.9501 7.34691 16.1328 7.34691C16.9358 7.34663 17.7234 7.58064 18.4046 8.02313C19.0858 8.4657 19.6331 9.09918 19.9818 9.8515C20.3305 10.604 20.4657 11.4436 20.371 12.2729C20.2763 13.1022 19.9558 13.8857 19.4481 14.533C18.9405 15.1802 18.2666 15.6645 17.5057 15.9314C16.7448 16.1985 15.9266 16.2378 15.1453 16.0453C14.3638 15.8529 13.6497 15.4358 13.0861 14.8409C12.5223 14.2457 12.1325 13.4969 11.9631 12.6806L11.8812 12.2861C11.8692 12.1851 11.859 12.084 11.8509 11.9827L11.8504 11.9773C11.8089 11.5367 11.7882 10.9181 11.8226 10.168C11.8641 9.42318 11.9708 8.55651 12.2077 7.64685C12.3331 7.19215 12.4855 6.72765 12.6731 6.27581C12.6953 6.22767 12.717 6.18001 12.7386 6.1328C12.9345 5.70449 13.113 5.31425 13.3627 4.95581L13.3727 4.9414L13.3815 4.92615C13.6219 4.50699 13.9362 4.13096 14.2752 3.75193L14.2853 3.74069L14.2944 3.72873C14.4256 3.55774 14.585 3.40729 14.7663 3.25297C14.8244 3.20354 14.8889 3.15043 14.9558 3.09525C15.0806 2.99248 15.2141 2.88254 15.331 2.77592C15.4865 2.64282 15.6568 2.53057 15.8409 2.41914C15.8986 2.38422 15.9607 2.34762 16.0248 2.3099C16.1546 2.23348 16.2922 2.15249 16.4158 2.07173L16.4242 2.06605C16.5679 1.96688 16.7227 1.8929 16.893 1.82232C16.9442 1.80109 17.0018 1.77828 17.0625 1.75432C17.1803 1.70776 17.309 1.6569 17.4214 1.60517C17.5192 1.56595 17.6072 1.52906 17.6879 1.49521C17.9143 1.40033 18.0839 1.32926 18.2522 1.29725L18.2654 1.29475L18.2784 1.29137C18.4388 1.24957 18.5786 1.21413 18.7082 1.18127C18.8066 1.15633 18.8991 1.13288 18.9903 1.10926C18.991 1.10909 18.9916 1.10893 18.9922 1.10876L19.217 1.05292Z"
              stroke="#6731EC"
              stroke-width="0.8"
            />
          </svg>
        </div>
        <div class="max-h-[120px] h-[100px]">
          <p class="text-sm text-balance">
            {{ data.review }}
          </p>
        </div>
        <hr class="w-full h-[2px] my-4 bg-gray-200" />
        <div class="flex items-start justify-between w-full">
          <div class="">
            <p class="!text-lg !ml-auto font-semibold">{{ data.name }}</p>
            <p class="text-sm text-gray-500">{{ data.position }}</p>
          </div>
          <div class="flex items-center pt-2">
            <div class="" v-for="(_, index) in 5" :key="index">
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.96001 3.48268H10.081C10.3049 3.49585 10.4564 3.6012 10.5354 3.79873C10.588 4.00943 10.5354 4.18721 10.3773 4.33207L7.78965 6.34691L8.79707 9.50745C8.84975 9.71815 8.79049 9.89593 8.61929 10.0408C8.42176 10.1593 8.23081 10.1527 8.04644 10.021L5.49826 8.02595L2.95008 10.021C2.76572 10.1527 2.57477 10.1593 2.37723 10.0408C2.20604 9.89593 2.14678 9.71815 2.19945 9.50745L3.20687 6.34691L0.619186 4.33207C0.46116 4.18721 0.408484 4.00943 0.46116 3.79873C0.540173 3.6012 0.691615 3.49585 0.915487 3.48268H4.05627L5.04394 0.341896C5.12295 0.131194 5.27439 0.0192585 5.49826 0.00608921C5.72213 0.0192585 5.87358 0.131194 5.95259 0.341896L6.96001 3.48268Z"
                  fill="#684DF4"
                />
              </svg>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script setup lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/scss";
import "swiper/scss/navigation";
// import "swiper/scss/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const modules = [Navigation, Pagination, Autoplay];

const customerReview = [
  {
    name: "Sajana Gautam",
    position: "CO-Owner at Asado",
    review:
      "Working with Detech Solution to develop our travel website was an absolute pleasure. ",
  },
  {
    name: "Alex P.",
    position: "CEO of Travellers Himalaya",
    review:
      "Objectively visualize error-free technology for B2B alignment. Monotonically harness an expanded array of models via effective collaboration.",
  },
  {
    name: "Binod Bista",
    position: "Founder at Healthtrack Apps",
    review:
      "Nepvent RMS revolutionized our restaurant operations with its comprehensive features and user-friendly interface",
  },
  {
    name: "Sajana Gautam",
    position: "CO-Owner at Asado",
    review:
      "Working with Detech Solution to develop our travel website was an absolute pleasure. ",
  },
  {
    name: "Alex P.",
    position: "CEO of Travellers Himalaya",
    review:
      "Objectively visualize error-free technology for B2B alignment. Monotonically harness an expanded array of models via effective collaboration.",
  },
  {
    name: "Binod Bista",
    position: "Founder at Healthtrack Apps",
    review:
      "Nepvent RMS revolutionized our restaurant operations with its comprehensive features and user-friendly interface",
  },
];
</script>
<style lang="scss" scoped>
.mySwiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
